import React, { useRef, useEffect } from "react"
import RichText from "@components/RichText"
import CustomLink from "@components/helpers/CustomLink"

import "@styles/components/slices/video-card-section.scss"

const VideoCard = ({ slice }) => {
  const card = slice.primary
  const videoRef = useRef(null)

  // autoplay when in view logic
  useEffect(() => {
    const videoElement = videoRef.current
    if (!videoElement) return

    const observer = new IntersectionObserver(
      entries => {
        const entry = entries[0]
        if (entry.isIntersecting) {
          // play when in view
          videoElement.play().catch(e => console.log("Autoplay blocked:", e))
        } else {
          // pause when not in view (if not already paused - race condition)
          if (!videoElement.paused) {
            videoElement.pause()
          }
        }
      },
      // play when 80% of video is visible
      { threshold: 0.8 },
    )

    observer.observe(videoElement)

    return () => {
      // cleanup to prevent memory leaks
      observer.disconnect()
    }
  }, [])

  return (
    <section className="video-card-section">
      <div className="video-card-section__wrapper">
        <div className="video-card-section__columns">
          <div className="video-card-section__copy">
            <div className="video-card-section__title">
              <RichText render={card.video_title?.richText} />
            </div>
            <div className="video-card-section__description">
              <RichText render={card.description?.richText} />
            </div>
            {card.button_link ? (
              <CustomLink
                className="button button-primary"
                target="_blank"
                url={card.button_link.url}
                type={card.button_link.link_type}
                label="Learn more"
              >
                Learn more
              </CustomLink>
            ) : null}
          </div>
          <div className="video-card-section__media">
            <video
              ref={videoRef}
              preload="metadata"
              poster={card.video_poster.url}
              muted
              loop
              playsInline
              controls
              className="video-card-section__video"
            >
              <source src={card.video_link.url} />
            </video>
            {card.video_source?.text ? (
              <div className="video-card-section__source">
                <div>Source From:</div>
                <div>{card.video_source?.text}</div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </section>
  )
}

export default VideoCard
